import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function loginUser(credentials) {
  const response = await apiClient.post("/api/v1/auth/jwt/create/", credentials);
  return response.data;
}

function useLoginUser() {
  return useMutation({ mutationFn: loginUser });
}

export { useLoginUser };
